angular.module('tgaApp').controller('PollController', [
  '$scope', '$translate', 'gameTrackingService', 'analyticsService',
  'soundService', 'APIService', 'gameDataService', '$document', 'utilityService',
  function (
    $scope, $translate, gameTrackingService, analyticsService, soundService, APIService, gameDataService,
    $document, utilityService,
  ) {
    $scope.initialize = () => {
      $scope.reset();
    };
    $scope.questionVariables = {
      hasFeedback: false,
      feedbackComplete: false,
      feedbackText: '',
      questionAnswered: false,
      questionCorrect: false,
      timedOut: false,
      show_results: false,
      chart_type: false,
      answers: -1,
    };
    $scope.clickedAnswerData = {
      clickedAnswerPath: null,
    };

    $scope.submitAnswer = function (id) {
      $scope.questionVariables.answers = [id];
      $scope.gameData.pollCount++;
      $scope.$broadcast('timer-stop');
      angular.element(`.answer-${id}`).addClass('selected');
      $scope.stopQuestionAudio($scope.question.question_id);
      if (this.isSubmitted) return;
      $scope.error = null;
      const data = gameTrackingService.get();
      $scope.submitted = true;
      $scope.answer = id;
      if (!$scope.questionVariables.timedOut) {
        // get the next question id from the answer you choose
        const myAnswer = $scope.question.answers.filter((obj) => obj.answer_id === id);
        $scope.gameData.nextCardId = myAnswer[0].next_question_id;
      }
      $scope.gameData.questionAnswered = true;
      APIService.reportAnswer({
        answer_id: $scope.answer,
        game_id: $scope.gameData.data.game_id,
        question_id: $scope.question.question_id,
        correct: true,
        time: Date.now() - $scope.questionTime,
      },
      (response, success, status) => {
        if (!success) {
          $scope.reset();
          $scope.error = $translate.instant(`scenarios.error.${status}`).toString();
          return;
        }
        $scope.isAnswered = true;
        $scope.answeredCorrect = response.correct;
        $scope.questionVariables.questionCorrect = $scope.answeredCorrect;
        /** Points * */
        // Determine points awarded
        $scope.pointsAwarded = null;
        const selectedAnswer = $scope.question.answers.filter((obj) => obj.answer_id === id);
        if (selectedAnswer.length && selectedAnswer[0].points) {
          $scope.pointsAwarded = $scope.$parent.getPoints(selectedAnswer[0].points);
        }
        $scope.questionVariables.correct = $scope.answeredCorrect;
        $scope.questionVariables.questionAnswered = true;

        // add question to history modal
        const answersWithSelection = angular.copy($scope.question.answers);
        answersWithSelection.answerObject = $scope.questionVariables;
        for (let i = 0; i < $scope.question.answers.length; i++) {
          answersWithSelection[i].userSelected = false;
        }
        for (let i = 0; i < $scope.question.answers.length; i++) {
          for (let j = 0; j < $scope.question.answers.length; j++) {
            if ($scope.question.answers[j].answer_id === id) {
              answersWithSelection[j].userSelected = true;
            }
          }
        }
        $scope.gameData.answerHistory.push({
          questionData: angular.copy($scope.question),
          answerData: answersWithSelection,
          open: false,
        });
        $scope.$emit('calculatePoints', { points: $scope.$parent.getPoints($scope.pointsAwarded) });
        // eslint-disable-next-line max-len
        $scope.$emit('showFeedbackResults', { data: $scope.question, returned: response, questionVariables: $scope.questionVariables });

        analyticsService.sendEvent({
          category: 'question',
          action: 'answered',
          label: $scope.answeredCorrect ? 'correct' : 'incorrect',
          value: $scope.question.question_id,
        });
        $scope.$emit('questionAnswered');
      },
      () => {
        $scope.reset();
        $scope.error = $translate.instant('scenarios.error.connection-error').toString();
      });
      gameTrackingService.update('questionsCorrect', data.questionsCorrect + 1);
      gameTrackingService.update('score', data.score + $scope.pointsAwarded);
      gameTrackingService.update('pollCounter', data.pollCounter++);
      const isUniqueCorrect = data.uniqueCorrect.some((q_id) => $scope.question.question_id === q_id);
      if (!isUniqueCorrect) {
        const arr = data.uniqueCorrect.concat([$scope.question.question_id]);
        gameTrackingService.update('uniqueCorrect', arr);
      }
    };

    $scope.$on('countdown-complete', () => {
      $scope.questionVariables.timedOut = true;
      $scope.answeredCorrect = false;
      $scope.gameData.nextCardId = $scope.question.next_question_id_timeout;
      $scope.isAnswered = false;
      $scope.submitAnswer();
    });
    $scope.reset = () => {
      $scope.submitted = false;
      $scope.answeredCorrect = null;
      $scope.answerArray = [];
      $scope.error = null;
      $scope.isAnswered = false;
      $scope.focusedIndex = undefined;
      $scope.selectedItem = undefined;
      $scope.answer = null;
      $scope.question = $scope.$parent.currentQuestion;
      // eslint-disable-next-line max-len
      if ($scope.question.randomize_answers) $scope.question.answers = utilityService.shuffleArray($scope.question.answers);
      $scope.isMobile = $scope.$parent.isMobile;
      $scope.game = gameDataService.get();
      $scope.playAudio = $scope.$parent.playAudio;
      $scope.questionHasAudio = !!$scope.question?.audio?.url;
      $scope.questionTime = Date.now();
    };
    $scope.initialize();
  },
]);
